'use client';

import { Button } from 'react-bootstrap';
import {
  ChevronDoubleLeft,
  ChevronDoubleRight,
  ChevronLeft,
  ChevronRight,
} from 'react-bootstrap-icons';
import { fillTemplate, getVisiblePages, readMessage } from '../reviewUtils';

export default function ReviewPagination({
  currentPage,
  isLoading,
  messages,
  onPageChange,
  pages,
}) {
  if (pages <= 1) {
    return null;
  }

  const visiblePages = getVisiblePages(currentPage, pages);

  return (
    <div
      className="product-reviews__pagination"
      aria-label="Reviews pagination"
    >
      <div className="product-reviews__pagination-links">
        <Button
          variant="transparent"
          size="sm"
          className="app-button app-button--ghost app-button--compact"
          onClick={() => onPageChange(1)}
          disabled={isLoading || currentPage === 1}
        >
          <ChevronDoubleLeft
            size={16}
            aria-hidden="true"
            aria-label={readMessage(messages, 'reviewsList.first', 'First')}
          />
        </Button>
        <Button
          variant="transparent"
          size="sm"
          className="app-button app-button--ghost app-button--compact"
          onClick={() => onPageChange(currentPage - 1)}
          disabled={isLoading || currentPage === 1}
        >
          <ChevronLeft
            size={16}
            aria-hidden="true"
            aria-label={readMessage(
              messages,
              'reviewsList.previous',
              'Previous',
            )}
          />
        </Button>

        <div className="product-reviews__pagination-pages">
          {visiblePages.map((pageNumber, index) => {
            const previous = visiblePages[index - 1];
            const needsGap = previous && pageNumber - previous > 1;

            return (
              <span
                key={`review-page-${pageNumber}`}
                className="product-reviews__pagination-cluster"
              >
                {needsGap ? (
                  <span
                    className="product-reviews__pagination-ellipsis"
                    aria-hidden="true"
                  >
                    ...
                  </span>
                ) : null}
                <Button
                  variant="transparent"
                  className={`product-reviews__pagination-page${
                    pageNumber === currentPage ? ' is-active' : ''
                  }`}
                  onClick={() => onPageChange(pageNumber)}
                  disabled={isLoading || pageNumber === currentPage}
                >
                  {pageNumber}
                </Button>
              </span>
            );
          })}
        </div>

        <Button
          variant="transparent"
          size="sm"
          className="app-button app-button--ghost app-button--compact"
          onClick={() => onPageChange(currentPage + 1)}
          disabled={isLoading || currentPage >= pages}
        >
          <ChevronRight
            size={16}
            aria-hidden="true"
            aria-label={readMessage(messages, 'reviewsList.next', 'Next')}
          />
        </Button>
        <Button
          variant="transparent"
          size="sm"
          className="app-button app-button--ghost app-button--compact"
          onClick={() => onPageChange(pages)}
          disabled={isLoading || currentPage >= pages}
        >
          <ChevronDoubleRight
            size={16}
            aria-hidden="true"
            aria-label={readMessage(messages, 'reviewsList.last', 'Last')}
          />
        </Button>
      </div>
      <p className="product-reviews__pagination-meta">
        {fillTemplate(
          readMessage(
            messages,
            'reviewsList.pageStatus',
            'Page {{page}} of {{pages}}',
          ),
          { page: currentPage, pages },
        )}
      </p>
    </div>
  );
}
